export const PRIVACY_POLICY_URL = {
  en: 'https://wowflow.com/en/datenschutzerklaerung-app-april-2025/',
  de: 'https://wowflow.com/de/datenschutzerklaerung-app-april-2025/',
};
